// extracted by mini-css-extract-plugin
export var tooltip = "Tooltip_tooltip__8gFxz";